import { BaseModel } from '@Core';

export enum EnableStatus {
    Disable,
    Enable
}

export enum ActiveCell {
    Normal,
    Compatible
}

export enum DetectionMode {
    Normal,
    Advanced
}

export interface PMC8266MotionDetectionSchedule {
    ScheduleIndex: number;
    Schedule: string;
}

export interface PMC8266EventMotionDetection extends BaseModel {
    TriggerSensitivity: number;
    MotionEnable: EnableStatus;
    DynamicAnalysisEnable: EnableStatus;
    Activecell: ActiveCell;
    DetectionMode: DetectionMode;
    ScheduleList: PMC8266MotionDetectionSchedule[];
}